/**
 * Site-wide ordering switch. While `true`, the shop is "paused for
 * maintenance": every page shows `OrderingPausedBanner`, the configurators
 * render no add-to-cart, the cart pages render no lines or checkout link, and
 * every cart-mutating server action refuses with `ordering_paused`.
 *
 * Deliberately a code constant rather than an env var: `/foretag/konfigurera`
 * is prerendered at build time, where a throwing env read fails the whole
 * deploy, and a constant cannot be half-set in one environment. To reopen the
 * shop, set this to `false` and deploy.
 *
 * This does not touch Shopify. A buyer holding an old `checkoutUrl` can still
 * reach checkout until products are unpublished or the storefront is closed
 * in the Shopify admin.
 */
export const ORDERING_PAUSED = true;
